import gql from "graphql-tag";

const ADD_PROSPECT_TRAFFIC = gql`
  mutation addProspectTraffic($input: ProspectTrafficInput!) {
    addProspectTraffic(input: $input) {
      message
      code
    }
  }
`;

export default ADD_PROSPECT_TRAFFIC;
